// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1730":"8b3554b4","4573":"b8f73640","5111":"0d1fb7da","6468":"e0daec30"}[chunkId] + ".chunk.css";
};